import React, { useEffect } from 'react';
import loadable from '@loadable/component';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import SectionCustomColumn from '../PageBuilder/SectionBuilder/SectionCustomColumn/SectionCustomColumn';
import SectionCustomHeroOld from '../PageBuilder/SectionBuilder/SectionCustomHero/SectionCustomHeroOld';
import SectionCustomHero from '../PageBuilder/SectionBuilder/SectionCustomHero/SectionCustomHero';
import SectionUSP from '../PageBuilder/SectionBuilder/SectionUSP/SectionUSP';

import hero from '../../assets/heroHR.png';
import heroLR from '../../assets/heroLR.png';
import heroOld from '../../assets/heroOld.png';
import { landingPageHeroSection } from '../../config/configLayout';

import { GoogleAnalyticsHandler } from '../../analytics/handlers';
import { googleAnalyticsEnabled } from '../../config/configAnalytics';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const LandingPageComponent = props => {
  const { intl } = props;

  useEffect(() => {
    const analyticsHandler = new GoogleAnalyticsHandler();
    if (googleAnalyticsEnabled == true) {
      analyticsHandler.trackCustomEvent('Visit');
    }
  }, []);

  const pageAssetsData =
    landingPageHeroSection.variantType == 'old'
      ? {
          sections: [
            {
              sectionType: 'hero-old',
              sectionId: 'hero-section',
              svgImage: heroOld,
            },
            {
              sectionType: 'usp',
              sectionId: 'usp-section',
            },
            {
              sectionType: 'custom-column',
              sectionId: 'custom-column-1',
              title: intl.formatMessage({ id: 'LandingPage.title' }),
              text: intl.formatMessage({ id: 'LandingPage.text' }),
              blocks: [
                {
                  blockType: 'defaultBlock',
                  blockId: 'button-1',
                  callToAction: {
                    fieldType: 'internalButtonLink',
                    href: '/shop',
                    content: intl.formatMessage({ id: 'LandingPage.shopButton' }),
                  },
                },
                {
                  blockType: 'defaultBlock',
                  blockId: 'button-2',
                  callToAction: {
                    fieldType: 'externalButtonLink',
                    href: '/sell',
                    content: intl.formatMessage({ id: 'LandingPage.sellButton' }),
                  },
                },
              ],
            },
            {
              sectionType: 'columns',
              sectionId: 'two-columns-section',
              backgroundColor: '#1a1a1a',
              numColumns: 2,
              blocks: [
                {
                  blockType: 'defaultBlock',
                  blockId: 'column-1',
                  title: {
                    fieldType: 'heading3',
                    content: intl.formatMessage({ id: 'LandingPage.infoSection1Title' }),
                  },
                  text: {
                    fieldType: 'paragraph',
                    content: intl.formatMessage({ id: 'LandingPage.infoSection1Text' }),
                  },
                },
                {
                  blockType: 'defaultBlock',
                  blockId: 'column-2',
                  media: {
                    fieldType: 'video',
                    content:
                      'https://cdn.shopify.com/videos/c/o/v/340d56312a2d494f97bf82567a6e625d.mp4',
                  },
                },
              ],
            },
            {
              sectionType: 'columns',
              sectionId: 'one-column-section',
              numColumns: 1,
              blocks: [
                {
                  blockType: 'defaultBlock',
                  blockId: 'column-1',
                  title: {
                    fieldType: 'heading3',
                    content: intl.formatMessage({ id: 'LandingPage.infoSection2Title' }),
                  },
                  text: {
                    fieldType: 'paragraph',
                    content: intl.formatMessage({ id: 'LandingPage.infoSection2Text' }),
                  },
                },
              ],
            },
            {
              sectionType: 'columns',
              sectionId: 'two-columns-section-2',
              backgroundColor: '#1a1a1a',
              numColumns: 2,
              blocks: [
                {
                  blockType: 'defaultBlock',
                  blockId: 'column-1',
                  title: {
                    fieldType: 'heading3',
                    content: intl.formatMessage({ id: 'LandingPage.infoSection3Title' }),
                  },
                  text: {
                    fieldType: 'paragraph',
                    content: intl.formatMessage({ id: 'LandingPage.infoSection3Text' }),
                  },
                },
                {
                  blockType: 'defaultBlock',
                  blockId: 'column-2',
                  media: {
                    fieldType: 'video',
                    content:
                      'https://cdn.shopify.com/videos/c/o/v/aa0e500b0dcb407ba3ee8dcdb340b7eb.mp4',
                  },
                },
              ],
            },
          ],
        }
      : {
          sections: [
            {
              sectionType: 'hero',
              sectionId: 'hero-section',
              svgImage: hero,
              svgImageLR: heroLR,
              title: intl.formatMessage({ id: 'LandingPage.title' }),
              text: intl.formatMessage({ id: 'LandingPage.text' }),
              blocks: [
                {
                  blockType: 'defaultBlock',
                  blockId: 'button-1',
                  callToAction: {
                    fieldType: 'internalButtonLink',
                    href: '/shop',
                    content: intl.formatMessage({ id: 'LandingPage.shopButton' }),
                  },
                },
                {
                  blockType: 'defaultBlock',
                  blockId: 'button-2',
                  callToAction: {
                    fieldType: 'internalButtonLink',
                    href: '/sell',
                    content: intl.formatMessage({ id: 'LandingPage.sellButton' }),
                  },
                },
              ],
            },
            {
              sectionType: 'usp',
              sectionId: 'usp-section',
            },
          ],
        };

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData}
      options={{
        sectionComponents: {
          'custom-column': { component: SectionCustomColumn },
          'hero-old': { component: SectionCustomHeroOld },
          hero: { component: SectionCustomHero },
          usp: { component: SectionUSP },
        },
      }}
      currentPage={'LandingPage'}
    />
  );
};

LandingPageComponent.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(LandingPageComponent);
